import React, { useContext, useEffect, useRef, useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { MyContext } from '../context/Context'
import api from '../api/url'
import { PlusOutlined } from '@ant-design/icons'
import { Upload } from 'antd'
import styled from 'styled-components'
import { update_admin_data } from '../api/api'
import { toast } from 'react-toastify'
import FormError from '../components/FormError'

function Profile() {
    const { adminData, setAdminData, userType } = useContext(MyContext);
    const profileImage =
        [{
            uid: "-1",
            name: adminData.user_profile.split('/').pop(),
            status: 'done',
            url: `${api.imageUrl}${adminData.user_profile}`,
        }]
        ;

    const [fileListIns, setFileListIns] = useState(adminData.user_profile ? profileImage : []);
    const update_close_Ref = useRef();
    const [formError, setFormError] = useState({
        username: "",
        email: "",
        mobile_no: ""
    });


    const [inputUser, setInputUser] = useState({
        username: "",
        user_id: "",
        firstname: "",
        lastname: "",
        mobile_no: "",
        email: "",
        user_profile: "",
        delete_profile_image: false,
    });

    useEffect(() => {
        if (adminData) {
            setInputUser({
                username: adminData.username,
                user_id: adminData.id,
                firstname: adminData.firstname,
                lastname: adminData.lastname,
                mobile_no: adminData.mobile_no,
                email: adminData.email,
                user_profile: adminData.user_profile,
                delete_profile_image: false
            });
        }
    }, [adminData]);




    const handle_change = (e) => {
        const { name, value, files } = e.target;

        // Check if the input is for mobile number and limit it to 10 digits
        if (name === 'mobile_no' && value.length > 10) {
            return;
        }
        setInputUser({
            ...inputUser,
            [name]: files && files.length > 0 ? files[0] : value || ""
        });
    };


    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );

    const onChangeIns = ({ fileList: newFileList }) => {
        setFileListIns(newFileList);
        setInputUser({ ...inputUser, delete_profile_image: newFileList.length < 1 ? true : false })
    };

    console.log(fileListIns)
    const thumb_Before_upload = (file) => {
        const isImage = file.type.startsWith("image/");
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isImage || !isLt3M) {
            return Upload.LIST_IGNORE;
        }
        file.url = URL.createObjectURL(file);
        setInputUser({
            ...inputUser,
            user_profile: file,
        });
        setFileListIns([file]);
        return false;
    };

    const clearError = () => {
        const clearedErrors = {};

        Object.keys(formError).forEach(field => {
            clearedErrors[field] = "";
        });

        setFormError(clearedErrors);
    }

    // user update
    const admin_update_api_call = async () => {

        try {
            const { username,
                mobile_no,
                email
            } = inputUser

            const errors = {};

            if (!username) {
                errors.username = 'Please enter username!'
            }
            if (mobile_no) {
                const mobilePattern = /^[0-9]{10}$/;
                if (!mobilePattern.test(mobile_no)) {
                    errors.mobile_no = 'Please enter a valid 10-digit mobile number!'

                }
            }
            if (email) {
                const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
                if (!emailPattern.test(email)) {
                    errors.email = 'Please enter a valid email address!'
                }
            }

            setFormError(errors);

            if (Object.keys(errors).length !== 0) {
                return;
            }

            const formData = new FormData();
            Object.entries(inputUser).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    formData.append(key, value);
                }
            });

            const res = await update_admin_data(formData);

            if (res.status === 200) {

                const updatedAdminData = res.data.data[0];

                // Set new admin data in context
                if (updatedAdminData) {
                    console.log(updatedAdminData);
                    localStorage.setItem('admin_data', JSON.stringify(updatedAdminData));
                    setAdminData(updatedAdminData);
                }

                // Update inputUser state with new data
                setInputUser({
                    username: updatedAdminData.username,
                    user_id: updatedAdminData.user_id,
                    firstname: updatedAdminData.firstname,
                    lastname: updatedAdminData.lastname,
                    mobile_no: updatedAdminData.mobile_no,
                    email: updatedAdminData.email,
                    user_profile: updatedAdminData.user_profile,
                });

                // Update fileListIns for profile image
                updatedAdminData.user_profile ?
                    setFileListIns([
                        {
                            uid: '-1',
                            name: 'user_profile',
                            status: 'done',
                            url: `${api.imageUrl}${updatedAdminData.user_profile}`,
                        },
                    ])
                    : setFileListIns([]);
                    
                toast.success("Admin Profile Updated Successfully");
                update_close_Ref.current.click();
            }
        } catch (error) {
            console.error("Admin update API error", error);
        }
    };

    // console.log(adminData.user_profile)

    return (
        <div className="wrapper">

            {/*navbar and Sidebar*/}
            <Navbar />

            {
                userType !== 'delivery_boy' ? <Sidebar /> : ''
            }

            {/* Content Wrapper. Contains page content  */}
            <Section>
                <div className={`${userType !== 'delivery_boy' ? 'content-wrapper' : 'min-h-100vh'}`}>

                    {/* Content Header (Page header)  */}
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6 m-auto">
                                    <h1 className="m-0 text-center">Your Profile</h1>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* /.content - header  */}

                    {/* Main content  */}
                    <section className="content profile-page">
                        <div className="container-fluid">
                            {/* Small boxes (Stat box)  */}
                            <div className='row'>
                                <div className="col-xl-5 col-lg-7 col-md-8 col-sm-10 col-11 m-auto">

                                    {/* Profile Image  */}
                                    <div className="card card-primary card-outline">
                                        <div className="card-body box-profile">

                                            <div className="mb-4 d-flex justify-content-center">
                                                <div className='admin-profile'>
                                                    {
                                                        adminData.user_profile ?
                                                            <img className="profile-user-img img-fluid img-circle" src={`${api.imageUrl}${adminData?.user_profile}`} alt="User profile picture" />
                                                            : <img className="profile-user-img img-fluid img-circle" src='https://www.pngall.com/wp-content/uploads/5/Profile-Male-PNG-Clipart.png' alt="User profile picture" />
                                                    }
                                                </div>
                                            </div>

                                            <ul className="list-group list-group-unbordered mb-3">
                                                <li className="list-group-item">
                                                    <b>Name</b> <a className="float-right">{`${adminData?.firstname} ${adminData?.lastname}`}</a>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Username</b> <a className="float-right">{adminData?.username}</a>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Email</b> <a className="float-right text-truncate">{adminData?.email}</a>
                                                </li>
                                                <li className="list-group-item">
                                                    <b>Mobile Number</b> <a className="float-right">{adminData?.mobile_no}</a>
                                                </li>
                                            </ul>
                                            {
                                                userType !== 'delivery_boy'
                                                    ? (
                                                        <div className='d-flex justify-content-center'>
                                                            <button className='btn btn-naariyal-green pr-4 pl-4'
                                                                data-toggle="modal"
                                                                data-backdrop="static"
                                                                data-target="#exampleModal"
                                                                onClick={() => {
                                                                    setInputUser({
                                                                        username: adminData.username,
                                                                        user_id: adminData.id,
                                                                        firstname: adminData.firstname,
                                                                        lastname: adminData.lastname,
                                                                        mobile_no: adminData.mobile_no,
                                                                        email: adminData.email,
                                                                        user_profile: adminData.user_profile,
                                                                    });
                                                                }}
                                                            >Update Profile</button>
                                                        </div>
                                                    )
                                                    : ''
                                            }

                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </section>

                    {/* Profile Update Modal  */}
                    <div className="modal fade edit-profile-model" id="exampleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <h5 className="modal-title text-center w-100" id="exampleModalLabel">Update Profile</h5>
                                    <button type="button" className="close" onClick={clearError} data-dismiss="modal" aria-label="Close" ref={update_close_Ref}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form
                                        action=""
                                        className=''
                                    >

                                        <div className="d-flex flex-column ">

                                            {/* iprofile update  */}
                                            <Upload
                                                className='m-auto'
                                                listType="picture-circle"
                                                fileList={fileListIns}
                                                accept=".jpg,.png,.jpeg"
                                                beforeUpload={thumb_Before_upload}
                                                onChange={onChangeIns}
                                                name='admin_profile_pic'
                                            >
                                                {fileListIns.length < 1 && uploadButton}
                                            </Upload>

                                            {/* fiest name update  */}
                                            <div className='mb-3'>
                                                <b>First Name</b>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="First name"
                                                    value={inputUser?.firstname}
                                                    name='firstname'
                                                    onChange={handle_change}
                                                />
                                            </div>

                                            {/* last name update  */}
                                            <div className='mb-3'>
                                                <b>Last Name</b>
                                                <input
                                                    type="text"
                                                    className="form-control "
                                                    placeholder="Last name"
                                                    value={inputUser?.lastname}
                                                    name='lastname'
                                                    onChange={handle_change}
                                                />
                                            </div>

                                            {/* username update  */}
                                            <div className='mb-3'>
                                                <b>Username</b>
                                                <input
                                                    type="text"
                                                    className="form-control text-lowercase"
                                                    placeholder="Username"
                                                    value={inputUser?.username}
                                                    name='username'
                                                    onChange={handle_change}
                                                />
                                                <FormError>
                                                    {formError.username ? formError.username : ''}
                                                </FormError>
                                            </div>

                                            {/* email update  */}
                                            <div className='mb-3'>
                                                <b>Email</b>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Email Id"
                                                    value={inputUser?.email}
                                                    name='email'
                                                    onChange={handle_change}
                                                />
                                                <FormError>
                                                    {formError.email ? formError.email : ''}
                                                </FormError>
                                            </div>

                                            {/* mobile number update  */}
                                            <div className=''>
                                                <b>Mobile Number</b>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Mobile Number"
                                                    value={inputUser?.mobile_no}
                                                    name='mobile_no'
                                                    onChange={handle_change}
                                                />
                                            </div>
                                            <FormError>
                                                {formError.mobile_no ? formError.mobile_no : ''}
                                            </FormError>
                                        </div>
                                    </form>
                                    {/* end form  */}
                                </div>
                                <div className="modal-footer d-flex justify-content-center border-0">
                                    <button type="button" className="btn btn-naariyal-green w-25 m-0" onClick={admin_update_api_call}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
                {/* /.content - wrapper  */}
            </Section>

            {/* footer  */}
            <Footer />

            {/* Control Sidebar  */}
            <aside className="control-sidebar control-sidebar-dark">
                {/* Control sidebar content goes here  */}
            </aside>
        </div >
    )
}

export default Profile

const Section = styled.div`
    .min-h-100vh{
        min-height: 100vh;
    }
`

